// ============================================================
//  Herkunft der Nutzungsdaten (Trace).
//  „Nie genutzt" ist ohne Zeitraum und Quelle eine Behauptung — kein
//  Berechtigungsteam entzieht auf dieser Basis etwas. Deshalb steht
//  an jeder Trace-Aussage, seit wann und woher.
// ============================================================
export const TRACE_META = {
  from: "2026-04-01",
  to: "2026-09-25",
  days: 177,
  source: "ST03N / STAD — Workload-Statistik je Konto und Berechtigungsobjekt",
  sourceShort: "ST03N / STAD",
  /** Was „kein Trace" bedeutet — ehrlich, nicht als „nie genutzt" verkauft. */
  noTrace: "Für diesen Benutzer liegt auf diesem System keine Workload-Statistik vor (im Zeitraum nicht erfasst). Trace gibt es je Benutzer und System, nie je Rolle: liegt eine Aufzeichnung vor, ist jede Rolle darauf genutzt oder nie genutzt.",
  /** Wie ein Berechtigungswert als genutzt gilt. */
  method: "Ein Wert gilt als genutzt, wenn im Zeitraum mindestens eine Transaktion ausgeführt wurde, deren Berechtigungsprüfung diesen Wert verlangt.",
} as const;

export const traceWindowLabel = () => "01.04.–25.09.2026 (177 Tage)";
